// extracted by mini-css-extract-plugin
export default {"layout":"layout_layout__emTve","content":"layout_content__8yNkj","container":"layout_container__T+lEo","footer":"layout_footer__UaLUY"};